import type { ConditionRule } from "./types";

export const fmt = (s: number) =>
  `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;

export const evalCondition = (
  condition: ConditionRule | null,
  answers: Record<string, any>,
): boolean => {
  if (!condition) return true;
  const ans = answers[condition.questionId];
  if (ans === undefined || ans === null || ans === "") return false;
  const val = condition.value;
  switch (condition.operator) {
    case "equals":
      return String(ans) === String(val);
    case "not_equals":
      return String(ans) !== String(val);
    case "contains":
      return String(ans).toLowerCase().includes(String(val).toLowerCase());
    case "gt":
      return Number(ans) > Number(val);
    case "lt":
      return Number(ans) < Number(val);
    default:
      return true;
  }
};
